/* Loupe – journal tag pills filter the list in place (Section Rendering API), no full page reload. */
(() => {
  if (window.loupeBlogFilter) return; window.loupeBlogFilter = true;
  const cache = new Map();
  const sectionOf = (el) => el.closest('.shopify-section');
  const urlFor = (href, sec) => { const u = new URL(href, location.href); u.searchParams.set('section_id', sec.id.replace('shopify-section-', '')); return u.href; };
  const get = (href, sec) => { const u = urlFor(href, sec); if (!cache.has(u)) cache.set(u, fetch(u).then((r) => (r.ok ? r.text() : Promise.reject(r.status)))); return cache.get(u); };
  async function show(href, sec, push) {
    sec.setAttribute('aria-busy', 'true'); sec.style.opacity = '.55'; sec.style.transition = 'opacity .2s';
    try {
      const html = await get(href, sec);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
      sec.innerHTML = fresh ? fresh.innerHTML : html;
      sec.querySelectorAll('.reveal').forEach((x) => x.classList.add('in'));
      if (push) history.pushState({ blogFilter: true }, '', href);
      const cur = sec.querySelector('.blg-tags [aria-current]'); cur && cur.focus({ preventScroll: true });
    } catch (e) { location.href = href; return; }
    finally { sec.removeAttribute('aria-busy'); sec.style.opacity = ''; }
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest('.blg-tags a[href]'); if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    const sec = sectionOf(a); if (!sec) return;
    e.preventDefault(); show(a.href, sec, true);
  });
  document.addEventListener('pointerover', (e) => { const a = e.target.closest && e.target.closest('.blg-tags a[href]'); if (a) get(a.href, sectionOf(a)); }, { passive: true });
  addEventListener('popstate', () => { const sec = document.querySelector('.blg')?.closest('.shopify-section'); if (sec && /\/blogs\//.test(location.pathname)) show(location.href, sec, false); });
})();
